import type { RefObject } from 'react';

import type { Reservation } from '../../../pages/cardex/api/useReservation';
import type { WhatsappTemplate } from '../../../pages/settings/whatsapp/useWhatsappTemplate';

import Button from '../Button';
import Text from '../Text';
import { formatDate, t } from '../../i18n/langue';
import { apercu } from './helpers';

/** Une date ISO de séjour, lisible au pouce : « 2 oct. ». */
function dateCourte(iso?: string | null): string {
    if (!iso) return '';
    const d = new Date(`${iso.slice(0, 10)}T12:00:00`);
    return Number.isNaN(d.getTime()) ? iso : formatDate(d, { day: 'numeric', month: 'short' });
}

/**
 * L'étape « Pour quelle réservation ? » de la feuille de modèles — extrait de #19
 * §4. N'apparaît que lorsque plusieurs réservations existent : **71 % des cas**
 * (une seule réservation) sont retenus d'office par `FeuilleModeles`, sans écran.
 */
interface EtapeChoixReservationProps {
    modele: WhatsappTemplate;
    reservations: Reservation[];
    titreRef: RefObject<HTMLHeadingElement>;
    onChoisir: (reservationId: number) => void;
}

export default function EtapeChoixReservation({ modele, reservations, titreRef, onChoisir }: EtapeChoixReservationProps) {
    return (
        <>
            <h2 ref={titreRef} tabIndex={-1} className="mb-1 outline-none">
                <Text variante="sousTitre" as="span">
                    {t('composeur.modeles.pourQuelleReservation')}
                </Text>
            </h2>
            <Text variante="petit" ton="attenue" className="mb-3">
                {apercu(modele).slice(0, 80)}
            </Text>

            <ul className="flex flex-col">
                {reservations.map((reservation) => (
                    <li key={reservation.id}>
                        <Button
                            libelle={`${dateCourte(reservation.date_arrival)} → ${dateCourte(reservation.date_departure)}`}
                            variante="discret"
                            alignement="debut"
                            pleineLargeur
                            onPress={() => onChoisir(reservation.id)}
                        />
                    </li>
                ))}
            </ul>
        </>
    );
}
